module.exports = __webpack_public_path__ + "static/media/imgPoC.4ebedc83.svg";